import { useState } from 'react';
import { updateVoucher } from 'services/orders';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import {
  formatErrorTextForImageDocuments,
  isFileValid,
  validFormatsForDocumentsIncludingImages
} from 'utils/validateFiles';

export const useUploadPaymentVoucherForOrder = () => {
  const [isLoading, setIsLoading] = useState(false);

  const uploadFile = async (orderId: number, file?: File) => {
    if (!file) return;

    const generateTemporalUrl = (file: File) => URL.createObjectURL(file);

    const validFile = isFileValid(
      file,
      validFormatsForDocumentsIncludingImages,
      10,
      formatErrorTextForImageDocuments,
      'El documento no debe superar los 10MB'
    );
    if (!validFile) return;

    setIsLoading(true);

    const temporalUrl = generateTemporalUrl(file);

    try {
      const formData = new FormData();
      formData.append('file', file);
      const dataFile = await updateVoucher(String(orderId), formData);
      if (dataFile) {
        return temporalUrl;
      }
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };
  return { uploadFile, isLoading };
};
